export const STORE_CREDIT_BUILDER_SECURITIZATION = 'STORE_CREDIT_BUILDER_SECURITIZATION';

export const CREDIT_BUILDER_ENROLL_START = 'CREDIT_BUILDER_ENROLL_START';
export const CREDIT_BUILDER_ENROLL_SUCCESS = 'CREDIT_BUILDER_ENROLL_SUCCESS';
export const CREDIT_BUILDER_ENROLL_FAIL = 'CREDIT_BUILDER_ENROLL_FAIL';